<app-table-generator
    *ngIf="tableInput"
    [widgetRef]="widgetRef"
    [tableInput]="tableInput"
></app-table-generator>
